import { useEffect, useState } from "react";
import api from "../../api/api";
import { Oval } from "react-loader-spinner";

const AddToPremium = ({owner})=>{


    const [onAdding, setOnAdding] = useState(false)
    const [offres, setOffres] = useState([])
    const [selectedDate, setSelectedDate] = useState({startDate : new Date(), endDate : null})
    const [selectedOffre, setSelectedOffre] = useState(null)




    const submit = async ()=>{

        setOnAdding(true)
        try{

            if(selectedOffre && owner.id && selectedDate.startDate && selectedDate.endDate){
                
                await api.post('/offer/addClient', {
                    offerId : selectedOffre, 
                    ownerId : owner.id, 
                    startDate : selectedDate.startDate,
                    endDate : selectedDate.endDate,
                })
            }


        }catch(e){
            
            alert('IL ya eu une erreur serveur')
        }
        
        setOnAdding(false)
        

    }


    useEffect(()=>{

        const getData = async ()=>{

            try {
                
                const data = await api.get('/offres');
                const files = await api.get('/Documents')
                console.log(files)
                
                setOffres(data.data)
                console.log(data)
                
            } catch (error) {
                console.log(error)
            }
            
        }

        getData()
        
    }, [])


    return (

        <div className="flex flex-col items-center justify-start w-screen max-w-md p-5 bg-white rounded-lg shadow-md">
            
            <div className="flex flex-col items-center justify-center mb-2">
                <img src={`${process.env.REACT_APP_API_PICTURE_URL}${owner.client.picture}`} className="block rounded-full h-28 w-28"/>
                <h1 className="my-4 font-bold">{owner.client.firstname}</h1>
            </div>

            <div className="w-full my-2">
                <p>Choisis l'offres</p>
                <select
                    onChange={(event)=>{
                        setSelectedOffre(event.target.value)
                    }}

                    className="w-full rounded-lg"
                >
                    {
                        offres.map((off, idx)=>{
                            
                            if(off.isActif){
                                
                                return(
                                <option value={off.id} key={idx}>
                                    {off.name}
                                </option>)
                            }else{

                                return false
                            }

                        })
                    }
                </select>
            </div>

            <div className="w-full my-2">
                <p>Fin</p>
                <input
                    type="date"
                    className="rounded-lg"
                    onChange={(event)=>{
                        setSelectedDate((meti)=>({...meti, endDate : event.target.value}))
                    }}
                />
            </div>

            {!onAdding && <div className="flex items-center justify-center w-full px-4 py-2 my-2 text-white bg-indigo-700 rounded-lg shadow-lg cursor-pointer hover:bg-indigo-800" onClick={async ()=>await submit()}>
                <span >
                    Soumettre
                </span>
            </div>}

            {onAdding && <div className="flex items-center justify-center my-2 ">
                <Oval
                    height={20}
                    width={20}
                    color="#ffffff"
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="#cccccc"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            </div>}
        </div>

    )

}


export default AddToPremium